module.exports = __webpack_public_path__ + "img/demonstration-text-item-line3.daff05fc.png";